module.exports = __webpack_public_path__ + "assets/images/b3b3bac7f70f7d4cd35c4cec9f450520.jpg";